import { CSSProperties } from "react";
import { Button, Carousel } from "react-bootstrap";
import { useParams } from "react-router";
import { games } from "../types";

export default function GameView() {
    let { gameTitle } = useParams();

    // Find the game based on the URL parameter
    let game = games.find(x => x.title.toLowerCase().replace(/ /g, "-") === gameTitle);

    return (
        <div>
            <h1>{game.title}</h1>
            <p>{game.description}</p>

            <Carousel style={styles.carousel}>
                {game.images.map((image, index) => (
                    <Carousel.Item key={index}>
                        <div style={styles.carouselImageContainer}>
                            <img
                                className="d-block"
                                src={`/images/games/${gameTitle}/${image}`}
                                alt={`${gameTitle} screenshot ${index + 1}`}
                                style={styles.carouselImage}
                            />
                        </div>
                    </Carousel.Item>
                ))}
            </Carousel>

            <a href={`${process.env.REACT_APP_FILE_SERVICE}/launcher.zip`} download>
                <Button>Download Launcher</Button>
            </a>
        </div >
    );
}

const styles: { [key: string]: CSSProperties } = {
    carouselImageContainer: {
        height: '400px', // Set desired height
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'black', // Fill background with black
    },
    carouselImage: {
        height: '100%',
        width: 'auto', // Keep the width automatic
        objectFit: 'cover', // Maintain aspect ratio
    },
    carousel: {
        marginBottom: 20
    }
};